import { ProposalResponse } from "src/redux/projects/state";

export interface CurrentResponse {
  proposalUuid: string;
  response: ProposalResponse;
}

/**
 * State
 * Implement User, Organization and Contact
 */
export interface State {
  currentResponses: CurrentResponse[];
}
export const initialState: State = {
  currentResponses: []
};



// WEBPACK FOOTER //
// ./src/redux/currentResponses/state.ts